import moment from 'moment';
import {
  OPEN_JOBS,
  CLOSE_JOBS,
  UPDATE_JOBS,
  START_CHECKING_JOBS,
  STOP_CHECKING_JOBS,
  ADD_GLOBAL_HANDLER,
  REMOVE_GLOBAL_HANDLER,
  GLOBAL_JOB_COMPLETED,
} from '../action-types/asyncJobTypes.js';
import { MongoDataAPI } from '../../utils/MongoDataAPI.js';

let lastJobs = []; // Store the last jobs to track changes

export function addGlobalAsyncJobHandler(handlerId, handler, meta = {}) {
  return {
    type: ADD_GLOBAL_HANDLER,
    payload: {
      id: handlerId,
      handler,
      meta,
    },
  };
}

export function removeGlobalAsyncJobHandler(handlerId) {
  return {
    type: REMOVE_GLOBAL_HANDLER,
    payload: handlerId,
  };
}

export function jobCompleted(changedJobs) {
  return {
    type: GLOBAL_JOB_COMPLETED,
    payload: changedJobs,
  };
}

export function openJobs() {
  return {
    type: OPEN_JOBS,
  };
}

export function closeJobs() {
  return {
    type: CLOSE_JOBS,
  };
}

export function updateJobs(jobs, dispatch) {
  // Do a bit of change tracking for global handlers
  jobs = jobs || [];
  const prevRunningJobs = lastJobs.filter(
    (job) => !['completed', 'failed'].includes(job.status)
  );
  const completedJobs = jobs.filter((job) =>
    ['completed', 'failed'].includes(job.status)
  );
  const changedJobs = completedJobs.filter((cjs) =>
    prevRunningJobs.find((pjs) => pjs._id === cjs._id)
  );
  if (changedJobs.length > 0) {
    dispatch(jobCompleted(changedJobs));
  }
  lastJobs = jobs; // Update the last jobs with the current jobs
  return {
    type: UPDATE_JOBS,
    payload: jobs,
  };
}

export function startCheckingJobs(
  dispatch,
  { disableRefresh = false, startCheckTime = null } = {}
) {
  const checkExpiryPeriod = 5 * 60 * 1000; // 5 min
  const checkInterval = 3 * 1000; // 3 sec
  const checkPeriodDays = 7; // 7 days
  // TODO: Check for token expiry
  const fetchJobs = async () => {
    try {
      const mongoDataAPI = new MongoDataAPI('AsyncJob');
      const { docs: jobs } = await mongoDataAPI.fetchData({
        count: false,
        query: {
          'audit.createdDate': {
            $gte: moment().subtract(checkPeriodDays, 'days').toDate(),
          },
        },
        sort: ['-audit.createdDate'],
        fields: ['description', 'progress', 'status', 'audit'],
        limit: 20,
      });
      dispatch(updateJobs(jobs, dispatch));
      return jobs;
    } catch (err) {
      console.error(err);
    }
  };
  // start a timer where you fetch jobs and keep updating
  fetchJobs();
  let lastJobs = [];
  let interval = null;
  if (!disableRefresh) {
    interval = setInterval(async () => {
      const now = new Date();
      if (startCheckTime) {
        const elapsed = now - startCheckTime;
        if (elapsed > checkExpiryPeriod) {
          console.info('Expiry for AsyncJob refresh, terminating automatic refresh.');
          dispatch(stopCheckingJobs());
        } else {
          await fetchJobs();
        }
      } else {
        await fetchJobs();
      }
    }, checkInterval);
  }
  return {
    type: START_CHECKING_JOBS,
    payload: interval,
  };
}

export function stopCheckingJobs() {
  // stop a timer
  return {
    type: STOP_CHECKING_JOBS,
  };
}
